/* globals
    Base64,
    rscpCfg,
    Control,
    ServerFormater,
    XmlElement,
    DATA_STATE_CLEAN,
    DATA_STATE_DIRTY
*/

/* eslint-disable no-unused-vars */
var SCORM_MODE_NORMAL = "normal",
    SCORM_MODE_REVIEW = "review",
    SCORM_MODE_BROWSE = "browse",

    SCORM_STATUS_PASSED = "passed",
    SCORM_STATUS_COMPLETED = "completed",
    SCORM_STATUS_FAILED = "failed",
    SCORM_STATUS_INCOMPLETE = "incomplete",
    SCORM_STATUS_BROWSED = "browsed",
    SCORM_STATUS_NOT_ATTEMPTED = "not attempted",
    SCORM_STATUS_UNKNOWN = "unknown",

    SCORM_EXIT_TIME_OUT = "time-out",
    SCORM_EXIT_SUSPEND = "suspend",
    SCORM_EXIT_LOGOUT = "logout",
    // NOTE: in SCORM 1.2, "" is actually considered normal rather than unknown
    SCORM_EXIT_NORMAL = "normal",
    SCORM_EXIT_UNKNOWN = "",

    SCORM_CREDIT = "credit",
    SCORM_CREDIT_NO = "no-credit",

    SCORM_ENTRY_AB_INITO = "ab-initio",
    SCORM_ENTRY_RESUME = "resume",
    SCORM_ENTRY_NORMAL = "",

    SCORM_TRUE_FALSE = "true-false",
    SCORM_CHOICE = "choice",
    SCORM_FILL_IN = "fill-in",
    SCORM_MATCHING = "matching",
    SCORM_PERFORMANCE = "performance",
    SCORM_SEQUENCING = "sequencing",
    SCORM_LIKERT = "likert",
    SCORM_NUMERIC = "numeric",
    SCORM_LONG_FILL_IN = "long-fill-in",
    SCORM_OTHER = "other",

    SCORM_CORRECT = "correct",
    // 1.2
    SCORM_WRONG = "wrong",
    // 2004
    SCORM_INCORRECT = "incorrect",
    SCORM_UNANTICIPATED = "unanticipated",
    SCORM_NEUTRAL = "neutral",

    SCORM_RUNTIME_NAV_REQUEST_CONTINUE = "continue",
    SCORM_RUNTIME_NAV_REQUEST_PREVIOUS = "previous",
    SCORM_RUNTIME_NAV_REQUEST_CHOICE = "choice",
    SCORM_RUNTIME_NAV_REQUEST_JUMP = "jump",
    SCORM_RUNTIME_NAV_REQUEST_EXIT = "exit",
    SCORM_RUNTIME_NAV_REQUEST_EXITALL = "exitAll",
    SCORM_RUNTIME_NAV_REQUEST_ABANDON = "abandon",
    SCORM_RUNTIME_NAV_REQUEST_ABANDONALL = "abandonAll",
    SCORM_RUNTIME_NAV_REQUEST_SUSPENDALL = "suspendAll",
    SCORM_RUNTIME_NAV_REQUEST_NONE = "_none_";
/* eslint-enable no-unused-vars */

//
// note - these values are always stored internally as SCORM 2004 values
//

/* eslint-disable camelcase, new-cap */
function ActivityRunTime (
    CompletionStatus,
    Credit,
    Entry,
    Exit,
    Location,
    Mode,
    ProgressMeasure,
    ScoreRaw,
    ScoreMax,
    ScoreMin,
    ScoreScaled,
    SuccessStatus,
    SuspendData,
    TotalTime,
    TotalTimeTracked,
    AudioLevel,
    LanguagePreference,
    DeliverySpeed,
    AudioCaptioning,
    Comments,
    CommentsFromLMS,
    Interactions,
    Objectives
) {
    this.CompletionStatus = CompletionStatus;
    this.Credit = Credit;
    this.Entry = Entry;
    this.Exit = Exit;
    this.Location = Location;
    this.Mode = Mode;
    this.ProgressMeasure = ProgressMeasure;
    this.ScoreRaw = ScoreRaw;
    this.ScoreMax = ScoreMax;
    this.ScoreMin = ScoreMin;
    this.ScoreScaled = ScoreScaled;
    this.SuccessStatus = SuccessStatus;
    this.SuspendData = SuspendData;
    this.TotalTime = TotalTime;
    this.TotalTimeTracked = TotalTimeTracked;
    this.AudioLevel = AudioLevel;
    this.LanguagePreference = LanguagePreference;
    this.DeliverySpeed = DeliverySpeed;
    this.AudioCaptioning = AudioCaptioning;
    this.Comments = Comments;
    this.CommentsFromLMS = CommentsFromLMS;
    this.Interactions = Interactions;
    this.Objectives = Objectives;

    this.LookAheadCompletionStatus = CompletionStatus;
    this.LookAheadSuccessStatus = SuccessStatus;

    this.CompletionStatusChangedDuringRuntime = false;
    this.SuccessStatusChangedDuringRuntime = false;

    this.SessionTime = "";
    this.SessionTimeTracked = "";
    this.NavRequest = SCORM_RUNTIME_NAV_REQUEST_NONE;

    this.DataState = DATA_STATE_CLEAN;
}

/* eslint-disable no-use-before-define */
ActivityRunTime.prototype.ResetState = ActivityRunTime_ResetState;
ActivityRunTime.prototype.GetXml = ActivityRunTime_GetXml;
ActivityRunTime.prototype.toString = ActivityRunTime_toString;
ActivityRunTime.prototype.SetDirtyData = ActivityRunTime_SetDirtyData;
ActivityRunTime.prototype.IsValidObjectiveIndex = ActivityRunTime_IsValidObjectiveIndex;
ActivityRunTime.prototype.IsValidInteractionIndex = ActivityRunTime_IsValidInteractionIndex;
ActivityRunTime.prototype.IsValidInteractionObjectiveIndex = ActivityRunTime_IsValidInteractionObjectiveIndex;
ActivityRunTime.prototype.IsValidInteractionCorrectResponseIndex = ActivityRunTime_IsValidInteractionCorrectResponseIndex;
ActivityRunTime.prototype.AddObjective = ActivityRunTime_AddObjective;
ActivityRunTime.prototype.AddInteraction = ActivityRunTime_AddInteraction;
ActivityRunTime.prototype.AddComment = ActivityRunTime_AddComment;
ActivityRunTime.prototype.FindObjectiveWithId = ActivityRunTime_FindObjectiveWithId;
/* eslint-enable no-use-before-define */

function ActivityRunTime_ResetState () {
    var lessonMode = rscpCfg.get("registrationToDeliver").LessonMode;

    this.CompletionStatus = SCORM_STATUS_UNKNOWN;
    // credit shouldn't have to change
    // this.Credit = Credit;
    this.Entry = SCORM_ENTRY_AB_INITO;
    this.Exit = SCORM_EXIT_UNKNOWN;
    this.Location = null;

    if (lessonMode !== SCORM_MODE_REVIEW && lessonMode !== SCORM_MODE_BROWSE) {
        this.Mode = SCORM_MODE_NORMAL;
    }

    this.ProgressMeasure = null;
    this.ScoreRaw = null;
    this.ScoreMax = null;
    this.ScoreMin = null;
    this.ScoreScaled = null;
    this.SuccessStatus = SCORM_STATUS_UNKNOWN;
    this.SuspendData = null;
    this.TotalTime = "PT0H0M0S";
    this.TotalTimeTracked = "PT0H0M0S";

    if (Control.Package.Properties.MakeStudentPrefsGlobalToCourse !== true) {
        this.AudioLevel = 1;
        this.LanguagePreference = "";
        this.DeliverySpeed = 1;
        this.AudioCaptioning = 0;
    }

    this.Comments = [];
    this.CommentsFromLMS = [];
    this.Interactions = [];

    this.Objectives = [];

    this.LookAheadCompletionStatus = this.CompletionStatus;
    this.LookAheadSuccessStatus = this.SuccessStatus;

    this.SessionTime = "";
    this.NavRequest = SCORM_RUNTIME_NAV_REQUEST_NONE;

    this.CompletionStatusChangedDuringRuntime = false;
    this.SuccessStatusChangedDuringRuntime = false;

    this.SetDirtyData();
}

function ActivityRunTime_GetXml (activityId) {
    var ServerFormat = new ServerFormater(),
        xml = new XmlElement("ART"),
        i;

    xml.AddAttribute("AI", activityId);
    xml.AddAttribute("CS", ServerFormat.ConvertCompletionStatus(this.CompletionStatus));
    xml.AddAttribute("C", ServerFormat.ConvertCredit(this.Credit));
    xml.AddAttribute("E", ServerFormat.ConvertEntry(this.Entry));
    xml.AddAttribute("Ex", ServerFormat.ConvertExit(this.Exit));

    if (this.Location !== null) {
        xml.AddAttribute("L", ServerFormat.TrimToLength(this.Location, 1000));
    }

    xml.AddAttribute("M", ServerFormat.ConvertMode(this.Mode));

    if (this.ProgressMeasure !== null) {
        xml.AddAttribute("PM", this.ProgressMeasure);
    }
    if (this.ScoreRaw !== null) {
        xml.AddAttribute("SR", this.ScoreRaw);
    }
    if (this.ScoreMax !== null) {
        xml.AddAttribute("SM", this.ScoreMax);
    }
    if (this.ScoreMin !== null) {
        xml.AddAttribute("SMi", this.ScoreMin);
    }
    if (this.ScoreScaled !== null) {
        xml.AddAttribute("SS", this.ScoreScaled);
    }

    xml.AddAttribute("SuS", ServerFormat.ConvertSuccessStatus(this.SuccessStatus));

    if (this.SuspendData !== null) {
        // eslint-disable-next-line no-control-regex
        if (/^[\x00-\x7F]*$/.test(this.SuspendData)) {
            xml.AddAttribute("SD", ServerFormat.TrimToLength(this.SuspendData, Control.Package.Properties.SuspendDataMaxLength));
            xml.AddAttribute("SDE", false);
        }
        else {
            xml.AddAttribute("SD", ServerFormat.TrimToLength(Base64.encode(this.SuspendData), Control.Package.Properties.SuspendDataMaxLength));
            xml.AddAttribute("SDE", true);
        }
    }

    xml.AddAttribute("TT", ServerFormat.ConvertTimeSpan(this.TotalTime));
    xml.AddAttribute("TTT", ServerFormat.ConvertTimeSpan(this.TotalTimeTracked));
    xml.AddAttribute("AL", this.AudioLevel);
    xml.AddAttribute("LP", ServerFormat.TrimToLength(this.LanguagePreference, 250));
    xml.AddAttribute("DS", this.DeliverySpeed);
    xml.AddAttribute("AC", this.AudioCaptioning);

    for (i = 0; i < this.Comments.length; i += 1) {
        xml.AddElement(this.Comments[i].GetXml(activityId, i, false));
    }

    for (i = 0; i < this.CommentsFromLMS.length; i += 1) {
        xml.AddElement(this.CommentsFromLMS[i].GetXml(activityId, i, true));
    }

    for (i = 0; i < this.Interactions.length; i += 1) {
        xml.AddElement(this.Interactions[i].GetXml(activityId, i));
    }

    for (i = 0; i < this.Objectives.length; i += 1) {
        xml.AddElement(this.Objectives[i].GetXml(activityId, i));
    }

    return xml.toString();
}

function ActivityRunTime_toString () {
    return "RunTimeData - CompletionStatus=" + this.CompletionStatus + ", SuccessStatus=" + this.SuccessStatus;
}

function ActivityRunTime_SetDirtyData () {
    this.DataState = DATA_STATE_DIRTY;
}

function ActivityRunTime_IsValidObjectiveIndex (index) {
    //
    // we can only modify objectives that already exist and we can only add a new objective
    // at the slot right above the current max slot
    //
    index = parseInt(index, 10);
    if (index <= this.Objectives.length) {
        return true;
    }

    return false;
}

function ActivityRunTime_IsValidInteractionIndex (index) {
    //
    // we can only modify interactions that already exist and we can only add a new interaction
    // at the slot right above the current max slot
    //
    index = parseInt(index, 10);
    if (index <= this.Interactions.length) {
        return true;
    }

    return false;
}

function ActivityRunTime_IsValidInteractionObjectiveIndex (interactionIndex, objectiveIndex) {
    interactionIndex = parseInt(interactionIndex, 10);
    objectiveIndex = parseInt(objectiveIndex, 10);

    if (this.Interactions[interactionIndex]) {
        if (objectiveIndex <= this.Interactions[interactionIndex].Objectives.length) {
            return true;
        }

        return false;
    }

    // if we haven't established this interaction yet, then the only valid objective index is 0
    if (objectiveIndex === 0) {
        return true;
    }

    return false;
}

function ActivityRunTime_IsValidInteractionCorrectResponseIndex (interactionIndex, responseIndex) {
    interactionIndex = parseInt(interactionIndex, 10);
    responseIndex = parseInt(responseIndex, 10);

    if (this.Interactions[interactionIndex]) {
        if (responseIndex <= this.Interactions[interactionIndex].CorrectResponses.length) {
            return true;
        }

        return false;
    }

    // if we haven't established this interaction yet, then the only valid response index is 0
    if (responseIndex === 0) {
        return true;
    }

    return false;
}

function ActivityRunTime_AddObjective () {
    /* globals ActivityRunTimeObjective */
    this.Objectives[this.Objectives.length] = new ActivityRunTimeObjective(
        null,
        SCORM_STATUS_UNKNOWN,
        SCORM_STATUS_UNKNOWN,
        null,
        null,
        null,
        null,
        null,
        null
    );
}

function ActivityRunTime_AddInteraction () {
    /* globals ActivityRunTimeInteraction */
    this.Interactions[this.Interactions.length] = new ActivityRunTimeInteraction(
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        [],
        []
    );
}

function ActivityRunTime_AddComment () {
    /* globals ActivityRunTimeComment */
    this.Comments[this.Comments.length] = new ActivityRunTimeComment(
        null,
        null,
        null,
        null,
        null
    );
}

function ActivityRunTime_FindObjectiveWithId (id) {
    var i;

    for (i = 0; i < this.Objectives.length; i += 1) {
        if (this.Objectives[i].Identifier === id) {
            return this.Objectives[i];
        }
    }

    return null;
}
